/**
 *
 * Play Videos
 *
 * classes for animation instead of just display block
 * what is the expected transition between level 2 and 3
 *
 * add urls to application level page?
 *
 */


 ( function( ) {
	'use strict';

	const body = document.body;
	const mapButtonsArray = document.querySelectorAll('#map-button');
	const mapVideo = document.getElementById('map-video');
	const mapVideoWebm = document.getElementById('map-video-webm');
	const mapVideoMp4 = document.getElementById('map-video-mp4');
	const homeButton = document.getElementById('home-button');
	const backButton = document.getElementById('back-button');
	const backButtonDetail = document.getElementById('back-button-detail');
	let videoLength = 3200;
	const bldgViewArray = document.querySelectorAll('.bldg-view');
	const detailViewArray = document.querySelectorAll('.detail-view');



	/**
	 * click play video, set out video
	 */
	function playInSetOut() {
		let name = this.getAttribute('name');
		let inVideoSrc = '/assets/videos/' + name + '-in';
		let outVideoSrc = '/assets/videos/' + name + '-out';

		/* pause any playing videos */
		mapVideo.pause();

		/* update source to in video */
		mapVideoWebm.setAttribute('src', inVideoSrc + '.webm');
		mapVideoMp4.setAttribute('src', inVideoSrc + '.mp4');
		mapVideo.load();
		mapVideo.play();

		/* add name and out video src to localstorage */
		localStorage.setItem( 'building' , name );
		localStorage.setItem( 'out-video-source', outVideoSrc );


		/* level1 to level2 transition */
		body.classList.remove( 'level1--active' );
		body.classList.add( 'level2--transitioning' );

		setTimeout(function() {
			body.classList.remove( 'level2--transitioning' );
			body.classList.add( 'level2--active' );
			mapVideo.setAttribute( 'poster', '/assets/videos/' + name + '.jpg');

			document.getElementById( name + '-building' ).classList.remove( 'hide' );
		}, videoLength)

		setTimeout(function() {
			document.getElementById( name + '-building' ).classList.add( 'bldg-view--active' );
		}, videoLength + 500 );
	}


	/**
	 *
	 * Play Back button video and transition
	 */
	function backToMap() {
		let outVideoLs = localStorage.getItem('out-video-source');
		mapVideo.pause();
		mapVideoWebm.setAttribute('src', outVideoLs + '.webm');
		mapVideoMp4.setAttribute('src', outVideoLs + '.mp4');
		mapVideo.load();
		mapVideo.play();

		/* level2 to level1 transition */
		body.classList.add( 'level2--transitioning' );
		body.classList.remove( 'level2--active' );

		/* hide any level2 screens */
		bldgViewArray.forEach( el => el.classList.remove( 'bldg-view--active' ) );

		setTimeout(function() {
			body.classList.add( 'level1--active' );
			body.classList.remove( 'level2--transitioning' );
			mapVideo.setAttribute( 'poster', '/assets/videos/map.jpg');
		}, videoLength - 800 );

		setTimeout(function() {
			bldgViewArray.forEach( el => el.classList.add( 'hide' ) );
		}, videoLength + 500 );
	}


	/**
	 *
	 * Level 2 to Level 3
	 */
	const bldgButtonsArray = document.querySelectorAll('#bldg-button');
	function showDetailView() {
		let name = this.getAttribute( 'name' );
		localStorage.setItem( 'application', name );
		//document.getElementById( name ).classList.remove( 'hide' );

		body.classList.remove( 'level2--active' );
		body.classList.add( 'level3--active' );

		backButton.classList.add('back-button-detail');

		setTimeout(function() {
			document.getElementById( name ).classList.add( 'detail-view--active' );
		}, 100 );
	}

	/**
	 *
	 * Level 3 to Level 2
	 */
	function backToBuilding() {
		detailViewArray.forEach( el => el.classList.remove( 'detail-view--active' ) );
		body.classList.remove( 'level3--active' );
		body.classList.add( 'level2--active' );

		/* hide any level3 screens */
		setTimeout(function() {
			//detailViewArray.forEach( el => el.classList.add( 'hide' ) );
		}, 500 );
	}


	function reloadPage() {
		window.location.reload();
	}


	if( null != mapVideo ) {
		backButton.addEventListener( 'click', backToMap );
		backButtonDetail.addEventListener( 'click', backToBuilding );
		mapButtonsArray.forEach( el => el.addEventListener( 'click', playInSetOut ) );
		bldgButtonsArray.forEach( el => el.addEventListener( 'click', showDetailView ) );
		homeButton.addEventListener( 'click', reloadPage );
	}

} )();
